module.exports = __webpack_public_path__ + "img/logo.6fc2a902.svg";